import React, { createContext, useContext, useEffect, useMemo } from "react";
import { setPartnerDashboardAiContext } from "../../../utils/partnerPortal";

const PartnerDashboardContext = createContext(null);

export function PartnerDashboardProvider({ children, value }) {
  const memo = useMemo(
    () => ({
      variant: "partner",
      enabled: Boolean(value?.enabled),
      liveEnabled: Boolean(value?.liveEnabled),
      surveysEnabled: Boolean(value?.surveysEnabled),
      dominioIds: Array.isArray(value?.dominioIds) ? value.dominioIds : [],
      workspaces: Array.isArray(value?.workspaces) ? value.workspaces : [],
    }),
    [value?.enabled, value?.liveEnabled, value?.surveysEnabled, value?.dominioIds, value?.workspaces]
  );

  useEffect(() => {
    setPartnerDashboardAiContext({
      enabled: memo.enabled || memo.surveysEnabled || memo.liveEnabled,
      dominioIds: memo.dominioIds,
    });
    return () => setPartnerDashboardAiContext({ enabled: false, dominioIds: [] });
  }, [memo.enabled, memo.surveysEnabled, memo.liveEnabled, memo.dominioIds]);
  return <PartnerDashboardContext.Provider value={memo}>{children}</PartnerDashboardContext.Provider>;
}

export function usePartnerDashboardContext() {
  return useContext(PartnerDashboardContext);
}
